import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {BodyGenApiModel} from "../../api/models/body-gen.api-model";

export class BodyGenViewModel extends AbstractDictionaryViewModel<BodyGenApiModel> {
  public years: string;
  public displayName: string;
  constructor(protected apiModel: BodyGenApiModel) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  fromApiModel(apiModel: BodyGenApiModel): BodyGenViewModel {
    super.fromApiModel(apiModel);
    const yearFrom = apiModel.yearFrom || '?';
    const yearTo = apiModel.yearTo || '?';
    this.years = `${yearFrom} - ${yearTo}`;
    this.displayName = `${this.name} (${this.years})`;

    return this;
  }
}
